//views
import RecentObituariesListAsset from '../../../../Vue/Modules/Obituary/Custom/Site/RecentObituariesList.vue';

window.site_recent_obituaries_list_vue_instance = new Vue({
    el: '#recent-obituaries-list-asset',
    render: h => h(RecentObituariesListAsset)
});